<div (click)="$event.stopPropagation()">
  <!--   Necessary for when using inside another component e.g. table header   -->
  <mat-form-field [attr.data-test-id]="'mat-select-' + formControlName" [appearance]="appearance" [subscriptSizing]="subscriptSizing" class="w-full">
    <!--   LABEL   -->
    <mat-label *ngIf="config?.label">{{ config?.label }}</mat-label>

    <!--  SELECT  -->
    <mat-select
      [required]="config?.required || false"
      [minlength]="config?.required ? 1 : (config?.minlength ?? 0)"
      [disabled]="disabledField"
      [multiple]="config?.multiple"
      [(ngModel)]="selected"
      [placeholder]="placeholder || ''"
      [compareWith]="compareMatSelect"
      hideSingleSelectionIndicator="true"
      [attr.name]="attrName"
      (selectionChange)="onSelect($event)"
      [attr.data-test-id]="attrDataTestId"
      (click)="searchFocus()"
    >
      <!--   OTHERS LABEL   -->
      <mat-select-trigger class="flex items-center">
        <img *ngIf="selectedInlineImage" class="dropdown-img mr-2" alt="inline image" [src]="selectedInlineImage | imageLoading | async" />
        <sp-chips-listbox-option *ngIf="isArray(firstPartOfLabel)" [dataSource]="firstPartOfLabel" [showAvatar]="showAvatar" (removeChip)="remove($event)"></sp-chips-listbox-option>
        <span *ngIf="!isArray(firstPartOfLabel)" class="overflow-ellipsis overflow-hidden">{{ firstPartOfLabel.name ?? firstPartOfLabel }}</span>
      </mat-select-trigger>

      <!--   SEARCH   -->
      <mat-form-field *ngIf="config?.search" [appearance]="appearance" floatLabel="auto" class="w-[94%] text-sm ml-2" subscriptSizing="dynamic" (keydown)="$event.stopImmediatePropagation()">
        <input
          #search
          matInput
          [placeholder]="searchPlaceholder"
          (input)="onSearch($any($event.target))"
          (keydown.,)="addNewOptionInDropdown($event)"
          (keydown.enter)="addNewOptionInDropdown($event)"
        />
        <button mat-icon-button *ngIf="searchValue" matSuffix color="primary" class="clear-icon" title="Clear search" (click)="onClearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <!--  OPTIONS    -->
      <ng-template [ngIf]="dataSourceStringType">
        <mat-option *ngIf="!config?.multiple" value="">{{ selectOne }}</mat-option>
        <mat-option
          [class.hide]="hide(option)"
          [disabled]="config?.disableStringTypeOptions?.includes(option)"
          *ngFor="let option of dataSource"
          [attr.data-test-id]="formControlName + '_' + (option.toLowerCase() | replace: ' ' : '_') + '_option'"
          [value]="option"
        >
          {{ config?.titleCase ? (option | titlecase) : option }}
        </mat-option>
      </ng-template>
      <ng-template [ngIf]="dataSourceObjType">
        <ng-template [ngIf]="config?.enableMatOptGroup" [ngIfElse]="normal">
          <mat-optgroup *ngFor="let listGroup of dataSource" [label]="listGroup.name" [class.hideGrpLabel]="!!searchValue">
            <mat-option
              (onSelectionChange)="selectionChange($event)"
              [disabled]="option.disabled ? option.disabled : option.selected ? option.selected : false"
              [class.hide]="hide(option.name)"
              *ngFor="let option of listGroup.lists"
              [value]="option"
              [attr.data-test-id]="formControlName + '_' + (option.name.toString().toLowerCase() | replace: ' ' : '_') + '_option'"
            >
              <img *ngIf="option['imageUrl']" class="dropdown-img" alt="inline image" [src]="option['imageUrl'] | imageLoading | async" />
              {{ config?.titleCase ? (option.name | titlecase) : option.name }}
              <span *ngIf="option.subTitle" class="block text-xs text-gray-400">
                {{ option.subTitle }}
              </span>
            </mat-option>
          </mat-optgroup>
        </ng-template>
        <ng-template #normal>
          <!--  SELECT ALL (MULTIPLE) -->
          <!--  Select/deselect all in multiple select mode  -->
          <mat-checkbox class="ml-[5px]" color="primary" *ngIf="config?.multiple" [checked]="allSelected" [indeterminate]="someSelected" (change)="onSelectAll($event.checked)">
            {{ selectAll }}
          </mat-checkbox>
          <mat-option *ngIf="!config?.multiple" value="">{{ selectOne }}</mat-option>
          <ng-container *ngFor="let option of dataSource; let i = index">
            <mat-option
              (onSelectionChange)="selectionChange($event)"
              [disabled]="option.disabled ? option.disabled : option.selected ? option.selected : false"
              [class.hide]="hide(option.name)"
              [value]="option"
              [ngClass]="{ 'hide-checkbox': singleSelect }"
              [attr.data-test-id]="formControlName + '_' + (option.name?.toString().toLowerCase() | replace: ' ' : '_') + '_option'"
              [matTooltip]="option.tooltip || ''"
            >
              <div class="flex items-center" [ngClass]="{ 'gap-2': option['imageUrl'] }">
                <img *ngIf="option['imageUrl']" class="dropdown-img" alt="inline image" [src]="option['imageUrl'] | imageLoading | async" />
                <sp-avatar *ngIf="showAvatar" [user]="option" [size]="30" [fontSize]="12" [showToolTip]="true"> </sp-avatar>
                <span [ngClass]="{ 'ml-3': showAvatar }">{{ config?.titleCase ? (option.name | titlecase) : option.name }}</span>
                <span *ngIf="option.subTitle" class="block text-xs text-gray-400">
                  {{ option.subTitle }}
                </span>
              </div>
            </mat-option>
            <mat-divider *ngIf="i === config?.matDivider"></mat-divider>
          </ng-container>
        </ng-template>
      </ng-template>
    </mat-select>
    <mat-error *ngIf="config?.required"> {{ config?.requiredText }} </mat-error>
    <mat-error *ngIf="!config?.required && config?.minlengthError"> {{ config?.minLengthText }} </mat-error>
  </mat-form-field>
</div>
